import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import LoginActions from '../redux/loginRedux'
import PolarViewIcon from '@material-ui/icons/RemoveRedEye'
import { withErrorBoundary } from '../errors/ErrorBoundary'

const styles = theme => ({
  image: {
    height: '200px'
  },
  button: {},
  header: {
    backgroundColor: theme.palette.primary['50']
  },
  container: {
    overflowY: 'scroll',
    '&::-webkit-scrollbar': { width: '0px' }
  },
  link: {
    textDecoration: 'none'
  }
})

class SplashScreen extends PureComponent {
  render () {
    const { actions, authenticated, classes } = this.props

    if (authenticated) {
      return null
    }

    return (
      <Dialog open={!authenticated} classes={{ paper: classes.container }}>
        <Card className={classes.container}>
          { /*<CardHeader
            className={classes.header}
            title='Polar View'
            subheader='Ice Edge Monitoring'
            avatar={
              <Avatar>
                <PolarViewIcon />
              </Avatar>
            }
              /> */ }
          <CardContent className={classes.logo}>
            <img src={'https://s3-us-west-2.amazonaws.com/coresight-polarview/polarview-banner.png'} height='80px'/>
          </CardContent>
          <CardContent>
            <Typography component='p' type='caption'>
              To access the Community Ice Service website, <a className={classes.link} href='#' onClick={actions.loginRequested}>sign in or create an account</a>.
            </Typography>
          </CardContent>
          <CardContent>
            <Typography>
              Once you have an account, you can also access the service through an app for Android smartphones available for download  <a className={classes.link}  href='https://s3-us-west-2.amazonaws.com/coresight-polarview/polarview_community_ice_service.apk' target='_blank'>here</a>.
            </Typography>
          </CardContent>
          { /*<CardContent>
            <Button raised color='primary' onClick={actions.loginRequested}>
              Sign in or create an account
            </Button>
          </CardContent> */ }
          <CardContent>
            <Typography component='p' type='caption'>
              Polar View’s Community Ice Service provides near real-time sea ice information products to Arctic communities. The purpose of the service is for safe navigation on the ice. The service provides users access to optical and RADAR satellite imagery in a timely manner.  As well, sea ice fraction maps, snow thickness maps and Ice Travel maps are provided. The Ice Travel maps indicate areas of smooth ice, rough ice and mobile ice.
            </Typography>
          </CardContent>
            <CardMedia
              className={classes.image}
              image='https://s3-us-west-2.amazonaws.com/coresight-polarview/person.png'
              />
            <CardContent>
            <Typography component='p' type='caption'>
              Identifying locations of interest on the ice edge and selecting the shortest route around ice ridges and open water helps minimize travel time, fuel costs and equipment wear, as well as maximize the safety of travel on the ice, particularly as climate change is rendering traditional knowledge of the ice less reliable.
            </Typography>
          </CardContent>
          <CardMedia
            className={classes.image}
            image='https://s3-us-west-2.amazonaws.com/coresight-polarview/dogs.png'
          />
          <CardContent>
            <Typography component='p' type='caption'>
              Imagery is provided by the European Commission Copernicus program and NASA. The image products are produced by C-CORE and Copernicus Marine Service.
            </Typography>
          </CardContent>
          <CardMedia
            className={classes.image}
            image='https://s3-us-west-2.amazonaws.com/coresight-polarview/people.png'
          />
          <CardContent>
            <Typography component='p' type='caption'>
              The service is being implemented in collaboration with <a className={classes.link} href='https://www.c-core.ca'>C-CORE</a> and the <a className={classes.link} href='https://www.dmi.dk'>Danish Meteorological Institute</a>, and with the support of the <a className={classes.link} href='http://marine.copernicus.eu'>Copernicus Marine Service</a> and the <a className={classes.link} href='http://www.asc-csa.gc.ca'>Canadian Space Agency</a>.
            </Typography>
          </CardContent>
        </Card>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticated: state.login.authenticated
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      authenticate: () => dispatch(LoginActions.authenticate()),
      loginRequested: () => dispatch(LoginActions.loginRequested())
    }
  }
}

export default withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(SplashScreen)
))



// WEBPACK FOOTER //
// ./src/containers/SplashScreenPolarView.js